import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, matchPath, useLocation } from 'react-router-dom';
import './App.css';
import { apiService } from './components/Config/api.service';

import CreateUserCompany from './pages/Connexion/Inscription';
import Login from './pages/Connexion/Login';
import Deconnexion from './pages/Connexion/Deconnexion';
import MotDePasseOublie from './pages/MotDePasseOublie/MotDePasseOublie';
import Reinitialisation from './pages/MotDePasseOublie/Reinitialisation';
import CountrySelect from './pages/Connexion/CountrySelector';
import InvitationMotDePasse from './pages/Invitation/InvitationMotDePasse';


// import Header from './components/Header/Header';
import SidebarNav from './components/SideBar/SidebarNav';
import BarreHaute from './components/Navigation/BarreHaute';
import { ATraiterProvider } from './components/Navigation/ATraiter';
import { NotificationsProvider } from './components/Navigation/Notifications';
// import Footer from './components/Footer/Foot';

// Importez le nouveau composant LogoutModal
import LogoutModal from './pages/Connexion/LogoutModal';

import Home from './pages/Home/Home';
import AccueilSansGestion from './pages/Home/AccueilSansGestion';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
// import Calendar from './pages/Calendar/Calendar';

import Employees from './pages/Employee/Employees';
import EmployeeNew from './pages/Employee/EmployeeNew';
import Employee from './pages/Employee/EmployeeDetails';
import Contracts from './pages/Employee/Contract/Contracts';


import Primes from './pages/Primes/Primes';
// import Prime from './pages/Primes/PrimeDetails';

import DailySalaryInputs from './pages/Paie/DailySalaryInputs';
import PayrollHub from './pages/Paie/PayrollHub';
import PayslipsReport from './pages/Paie/Payslip/PayslipReport';


import FinancialStatements from './pages/FinancialStatements/FinancialStatements';

import TimeManagement from './pages/Leave/Leave';
import PresenceDuJour from './pages/Presence/PresenceDuJour';
import SupervisionRh from './pages/Rh/SupervisionRh';
import CircuitsValidation from './pages/Rh/CircuitsValidation';
import FeuillesTemps from './pages/Rh/FeuillesTemps';
import NotesFraisRh from './pages/Rh/NotesFraisRh';
import OrdresMission from './pages/Rh/OrdresMission';
import Departs from './pages/Rh/Departs';
import DossiersDisciplinaires from './pages/Rh/DossiersDisciplinaires';
import Annuaire from './pages/Annuaire/Annuaire';
import Organigramme from './pages/Organigramme/Organigramme';
import FicheDepart from './pages/Rh/FicheDepart';
import { NotificationContainer } from 'react-notifications';
// import HeaderProfile from './components/Header/HeaderProfile';
import Settings from './pages/Settings/Settings';
import GuideUtilisateur from './pages/Guide/GuideUtilisateur';
import { aOffreRh, memoriserIdentite, canAccessSettings, canImportPayroll, canSuperviserPresences, canSuperviserDemandesRh, canSuperviserFeuillesTemps, canEmettreOrdresMission, canGererDeparts, canGererDossiersDisciplinaires, canConsulterAnnuaire, canConsulterOrganigramme, isEmployee, canGererElementsRemuneration, canGererCollaborateurs, canGererBulletins, canConsulterEtats, canGererAbsences, canVoirTableauDeBord, canConsulterCollaborateurs, canConsulterBulletins } from './components/Auth/permissions';
import { resoudreIdentite } from './components/Auth/identite';
import EspaceEmploye from './pages/Espace/EspaceEmploye';
import Forbidden from './pages/Forbidden/Forbidden';
import NotFound from './pages/NotFound/NotFound';
// Deuxième import de permissions (ligne 51 déjà prise par un autre bolt en
// cours) : à fusionner à la consolidation post-merge (plan bolt 034,
// § Fichiers à modifier).

const protectedRoutePatterns = [
  '/',
  '/settings',
  '/guide',
  '/employees',
  '/employees/new',
  '/employees/:id',
  '/annuaire',
  '/organigramme',
  '/primes',
  '/etats',
  '/leave',
  '/leave/validation',
  '/paie/journaliers',
  '/presences',
  // Le lien du QR code d'un lieu (Yros/Kavero#459) : un salarié qui scanne
  // l'affiche n'est en général pas connecté. Sans cette entrée il voyait
  // « page introuvable », et le jeton du lien était perdu avant le login. Le
  // reste de l'espace salarié n'est pas ajouté : on n'y arrive pas par un lien
  // extérieur.
  '/espace/pointage',
  '/rh/supervision',
  '/rh/circuits-validation',
  '/rh/feuilles-temps',
  '/rh/notes-frais',
  '/rh/ordres-mission',
  '/rh/departs',
  '/rh/departs/:departId',
  '/rh/discipline',
  '/contracts',
  '/payslip/report',
];

const isProtectedPath = (pathname) =>
  protectedRoutePatterns.some((path) => matchPath({ path, end: true }, pathname));

const RedirectToLogin = () => {
  const location = useLocation();
  const from = {
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
  };

  return <Navigate to="/login" replace state={{ from }} />;
};

const UnauthenticatedFallback = () => {
  const location = useLocation();

  if (isProtectedPath(location.pathname)) {
    return <RedirectToLogin />;
  }

  return <NotFound />;
};



function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [isUserLoading, setIsUserLoading] = useState(true);
  // Statut d'authentification dérivé d'une validation serveur, jamais du
  // localStorage seul. 'checking' | 'authenticated' | 'unauthenticated'
  const [authStatus, setAuthStatus] = useState('checking');
  const isConnected = authStatus === 'authenticated';

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    // Charger l'état de la sidebar depuis localStorage
    const sidebarState = localStorage.getItem('sidebarCollapsed');
    if (sidebarState) {
      setIsSidebarCollapsed(sidebarState === 'true');
    }

    window.addEventListener('resize', handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    // localStorage ne sert que d'indice de cache : sans indice de session on
    // n'interroge pas le serveur (et on évite une boucle de redirection /login).
    const hasSessionHint = localStorage.getItem('isConnected') === 'true';
    if (!hasSessionHint) {
      setCurrentUser(null);
      setAuthStatus('unauthenticated');
      setIsUserLoading(false);
      return () => {
        isMounted = false;
      };
    }

    // La session est validée côté serveur avant d'afficher la moindre route
    // protégée. Le flag localStorage n'est jamais la source de vérité.
    // L'identité passe par C2 d'abord et `/user` en repli (voir identite.js) :
    // interroger `/user` en premier typerait un employé comme un interne.
    resoudreIdentite()
      .then((user) => {
        if (!isMounted) return;
        if (user) {
          setCurrentUser(user);
          memoriserIdentite(user);
          setAuthStatus('authenticated');
        } else {
          localStorage.removeItem('isConnected');
          localStorage.removeItem('user');
          setCurrentUser(null);
          setAuthStatus('unauthenticated');
        }
        setIsUserLoading(false);
      })
      .catch(() => {
        if (!isMounted) return;
        // Sur 401 l'interceptor gère déjà logout + redirection ; pour toute
        // autre erreur on refuse l'accès par défaut.
        localStorage.removeItem('isConnected');
        localStorage.removeItem('user');
        setCurrentUser(null);
        setAuthStatus('unauthenticated');
        setIsUserLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  // Surveiller les changements d'état de la sidebar
  useEffect(() => {
    const handleSidebarStateChange = () => {
      const sidebarState = localStorage.getItem('sidebarCollapsed');
      if (sidebarState) {
        setIsSidebarCollapsed(sidebarState === 'true');
      }
    };

    // Utiliser un écouteur d'événements de stockage pour détecter les changements
    window.addEventListener('storage', handleSidebarStateChange);

    return () => {
      window.removeEventListener('storage', handleSidebarStateChange);
    };
  }, []);

  const handleLogoutRequest = () => {
    setShowLogoutModal(true);
  };

  const handleLogoutConfirm = () => {
    apiService.logoutUser();
    setShowLogoutModal(false);
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  // L'employé a sa propre coquille : ni sidebar interne, ni marge gauche de
  // 250px sous un écran mobile-first. La coquille interne, elle, ne change pas
  // de condition pour un interne — seule sa garde s'affine.
  const estEmploye = isConnected && isEmployee(currentUser);
  const coquilleInterne = isConnected && !estEmploye;

  const settingsAllowed = currentUser ? canAccessSettings(currentUser) : false;
  const settingsElement = isUserLoading
    ? null
    : settingsAllowed
      ? <Settings />
      : <Forbidden />;

  // Même garde que /settings : cacher l'entrée de menu ne protège pas la route,
  // qui reste atteignable en tapant l'URL. Le proxy refuse déjà en 403, mais
  // autant ne pas afficher un écran inutilisable.
  const payrollImportAllowed = currentUser ? canImportPayroll(currentUser) : false;
  const payrollElement = isUserLoading
    ? null
    : payrollImportAllowed
      ? <PayrollHub />
      : <Forbidden />;

  // Même garde de confort d'interface que payrollElement : la donnée C12 est
  // déjà ouverte à tout compte interne côté proxy (review 029, § « trou du
  // rôle user »), ceci ne fait que cacher l'écran, pas l'autoriser.
  const presenceAllowed = currentUser ? canSuperviserPresences(currentUser) : false;
  const presenceElement = isUserLoading
    ? null
    : presenceAllowed
      ? <PresenceDuJour />
      : <Forbidden />;

  // Même garde de confort d'interface que presenceElement (bolt 046,
  // Yros/Kavero#71) : le proxy tranche l'accès, ceci ne fait que cacher
  // l'écran, pas l'autoriser.
  const supervisionRhAllowed = currentUser ? canSuperviserDemandesRh(currentUser) : false;
  const supervisionRhElement = isUserLoading
    ? null
    : supervisionRhAllowed
      ? <SupervisionRh />
      : <Forbidden />;

  // Feuilles de temps côté RH (Yros/Kavero#220) : un ajout du RH, absent d'une
  // société Paie seule. Même garde de confort d'interface que ci-dessus — la
  // barrière est le groupe gestionnaire côté Odoo.
  const feuillesTempsAllowed = currentUser ? canSuperviserFeuillesTemps(currentUser) : false;
  const feuillesTempsElement = isUserLoading
    ? null
    : feuillesTempsAllowed
      ? <FeuillesTemps />
      : <Forbidden />;

  // Notes de frais côté RH (Yros/Kavero#18) : le même prédicat que la
  // supervision, puisque la page décide les mêmes demandes par la même route.
  const notesFraisRhElement = isUserLoading
    ? null
    : supervisionRhAllowed
      ? <NotesFraisRh />
      : <Forbidden />;

  // Yros/Kavero#404 : cette route se montait sans aucune garde de rôle.
  // `protectedRoutePatterns` ne vérifie que l'authentification, et cacher
  // l'entrée de menu ne protège rien — l'adresse reste atteignable en la
  // tapant. Même forme que les gardes voisines.
  // Et ce n'est pas qu'un confort d'interface : l'écran est un CRUD sur
  // les primes, les avantages, les notes de frais et les déductions, donc sur
  // de l'argent retenu au bulletin. C'est aussi là qu'atterriront les
  // plafonds d'avance et de prêt (Yros/Kavero#406).
  const elementsRemunerationAllowed = currentUser ? canGererElementsRemuneration(currentUser) : false;
  const primesElement = isUserLoading
    ? null
    : elementsRemunerationAllowed
      ? <Primes />
      : <Forbidden />;

  // Même garde d'interface pour les ordres de mission (Yros/Kavero#127) :
  // la barrière est le groupe gestionnaire côté Odoo.
  const ordresMissionAllowed = currentUser ? canEmettreOrdresMission(currentUser) : false;
  const ordresMissionElement = isUserLoading
    ? null
    : ordresMissionAllowed
      ? <OrdresMission />
      : <Forbidden />;

  // Les écrans de gestion de la Paie (bolt 161, suite de #404) : même forme
  // que les gardes ci-dessus, en une fois. L'écran refusé n'est jamais monté,
  // donc aucun appel ne part ; `null` tant que l'utilisateur n'est pas résolu.
  const gardee = (autorise, ecran) => {
    if (isUserLoading) return null;
    return currentUser && autorise(currentUser) ? ecran : <Forbidden />;
  };

  // L'accueil complet rend les totaux de paie : un compte sans écran de
  // gestion reçoit un accueil minimal. Le choix se fait avant le montage de
  // `Home`, donc ses deux appels ne partent pas pour un compte refusé.
  const accueilElement = isUserLoading
    ? null
    : currentUser && canVoirTableauDeBord(currentUser)
      ? <Home />
      : <AccueilSansGestion />;

  return (
    <Router>
      {/* Les notifications persistantes : une lecture pour la cloche de la
          barre du haut et celle de l'espace du salarié (Yros/Kavero#21). Une
          société Paie seule n'en a pas : la route est sous `/api/rh/`, qu'Odoo
          lui refuse (C19). */}
      {/* Les compteurs « À traiter » : une lecture pour la barre du haut et
          les pastilles du menu (Yros/Kavero#416). */}
      <NotificationsProvider actif={isConnected && aOffreRh(currentUser)}>
      <ATraiterProvider actif={coquilleInterne} user={currentUser}>
        {coquilleInterne && <SidebarNav 
          isOpen={isSidebarOpen} 
          isCollapsed={isSidebarCollapsed}
          setIsCollapsed={setIsSidebarCollapsed}
          onLogoutRequest={handleLogoutRequest}
        />}
        <div className={`flex-1 p-5 bg-[var(--bg-color)] min-h-screen ${
          coquilleInterne ? (
            isSidebarCollapsed ? 'ml-[70px]' : 'ml-[250px]'
          ) : 'ml-0'
        } lg:transition-all lg:duration-300`}>
          {/* if the user is connected */}
          {/* {isConnected && <HeaderProfile />}           */}
          {coquilleInterne && <BarreHaute user={currentUser} />}
          <Routes>
            {authStatus === 'checking' ? (
              <Route
                path="*"
                element={
                  <div className="flex items-center justify-center min-h-screen">
                    <span className="animate-spin h-10 w-10 border-4 border-gray-200 border-t-orange-500 rounded-full"></span>
                  </div>
                }
              />
            ) : estEmploye ? (
              // Liste blanche C7 côté React, placée AVANT la branche interne.
              // Elle est structurelle : tout ce qui n'est pas déclaré ici rend
              // <Forbidden /> par la route `*`. Une liste noire oublierait
              // toujours l'écran livré demain.
              <>
                {/* `/*` : la coquille porte ses propres destinations (profil,
                    congés) en routes imbriquées — le retour du navigateur et
                    le lien profond doivent fonctionner. */}
                <Route path="/espace/*" element={<EspaceEmploye onLogoutRequest={handleLogoutRequest} offreRh={aOffreRh(currentUser)} user={currentUser} />} />
                <Route path="/" element={<Navigate to="/espace" replace />} />
                <Route path="/login" element={<Navigate to="/espace" replace />} />
                <Route path="*" element={<Forbidden />} />
              </>
            ) : isConnected ? (
              <>
                <Route path="/" element={accueilElement} />
                <Route path="/login" element={accueilElement} />
                {/* <Route path="/calendar" element={<Calendar />} /> */}
                <Route path="/403" element={<Forbidden />} />
                <Route path="/settings" element={settingsElement} />

                <Route path="/employees" element={gardee(canConsulterCollaborateurs, <Employees />)} />
                <Route path="/employees/new" element={gardee(canGererCollaborateurs, <EmployeeNew />)} />
                <Route path="/employees/:id" element={gardee(canConsulterCollaborateurs, <Employee />)} />

                <Route path="/primes" element={primesElement} />

                <Route path='/etats' element={gardee(canConsulterEtats, <FinancialStatements />)} />

                <Route path="/leave" element={gardee(canGererAbsences, <TimeManagement />)} />

                <Route path="/paie/journaliers" element={gardee(canGererBulletins, <DailySalaryInputs />)} />
                <Route path="/paie/rh" element={payrollElement} />
                <Route path="/presences" element={presenceElement} />
                <Route path="/rh/supervision" element={supervisionRhElement} />
                {/* Yros/Kavero#468 : même garde de confort que la supervision ;
                    Odoo réserve le réglage au groupe gestionnaire. */}
                <Route path="/rh/circuits-validation" element={isUserLoading ? null
                  : supervisionRhAllowed ? <CircuitsValidation /> : <Forbidden />} />
                <Route path="/rh/feuilles-temps" element={feuillesTempsElement} />
                <Route path="/rh/notes-frais" element={notesFraisRhElement} />
                <Route path="/rh/ordres-mission" element={ordresMissionElement} />
                <Route path="/rh/departs" element={gardee(canGererDeparts, <Departs />)} />
                <Route path="/rh/discipline" element={gardee(canGererDossiersDisciplinaires, <DossiersDisciplinaires />)} />
                <Route path="/annuaire" element={gardee(canConsulterAnnuaire, <Annuaire entete />)} />
                <Route path="/organigramme" element={gardee(canConsulterOrganigramme, <Organigramme />)} />
                <Route path="/rh/departs/:departId" element={gardee(canGererDeparts, <FicheDepart />)} />

                <Route path="/contracts" element={gardee(canGererCollaborateurs, <Contracts />)} />

                <Route path="/payslip/report" element={gardee(canConsulterBulletins, <PayslipsReport />)} />
                <Route path="/guide" element={<GuideUtilisateur />} />
                <Route path="*" element={<NotFound isAuthenticated />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/countryselect" element={<CountrySelect />} />
                <Route path="/inscription" element={<Navigate to="/login" replace />} />
                <Route path="/403" element={<Forbidden />} />
                <Route path="*" element={<UnauthenticatedFallback />} />
              </>
            )}
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/deconnexion" element={<Deconnexion />} />
            {/* Invitation Portail d'un salarié (RH) ; /invitation/ est celle d'un utilisateur de la Paie. */}
            <Route path="/invitation-portail/:jeton" element={<InvitationMotDePasse />} />
            <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
            <Route path="/reinitialisation/:jeton" element={<Reinitialisation />} />
            <Route path="/invitation/:jeton" element={<Reinitialisation mode="invitation" />} />
          </Routes>
          {/* <Footer /> */}
        </div>
        <NotificationContainer />

        {/* Utilisation du composant LogoutModal */}
        <LogoutModal 
          isOpen={showLogoutModal}
          onConfirm={handleLogoutConfirm}
          onCancel={handleLogoutCancel}
        />
      </ATraiterProvider>
      </NotificationsProvider>
    </Router>
  );
}

export default App;
